import { Injectable  } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ReportHistory } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private ajax: CustomAjax,
    private http: HttpClient,
  ) { }

  public GenerateReport(reportPath: string, reportName: string, parameters: { [key: string]: any }, rendertype: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.http.post("/Reports/GenerateReport", { reportPath, reportName, parameters, rendertype }, { responseType: 'blob' }).subscribe(
      (data) => {
        if (fn)
          fn(data);
      },
      (error: HttpErrorResponse) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ActivityHistoryGetByReport(fn: (data: any) => void, fnError: (error: any) => void):any {
    this.ajax.GetJSONData("/Reports/ActivityHistoryGetByReport", ``,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ReportActivityHistorySet(report: ReportHistory, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Reports/ReportActivityHistorySet", report,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
